export const PT_BR_DATE_FORMATS = {
	display: {
		dateA11yLabel: 'LL',
		dateInput: 'DD/MM/YYYY',
		monthYearA11yLabel: 'MMMM YYYY',
		monthYearLabel: 'MMM YYYY',
	},
	parse: {
		dateInput: 'DD/MM/YYYY',
	},
};
